import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedTab: 0,
    creditMapBusy: false,
};

const SalesPersonSlice = createSlice({
    name: "salesPerson",
    initialState,
    reducers: {
        setSalesPersonSelectedTab: (state, actions) => {
            state.selectedTab = actions.payload;
        },
        setCreditMapBusy: (state, actions) => {
            state.creditMapBusy = actions.payload;
        },
    }
});

export const { setSalesPersonSelectedTab, setCreditMapBusy } = SalesPersonSlice.actions;

export default SalesPersonSlice.reducer;
